<!--
 * @Autor: Haiting Zhao
 * @Date: 2021-12-07 14:56:01
 * @LastEditors: Haiting Zhao
 * @LastEditTime: 2021-12-20 08:45:47
 * @Description: file content
 * @FilePath: \Management-of-Scientific-Research-in-Universities-Front\src\views\kyproject\PaperEnd.vue
-->
<template>
  <div>
    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name:'WorkPlace' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>科研项目</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'EndApply' }">结题申请</el-breadcrumb-item>
      <!-- <el-breadcrumb-item>结题申请</el-breadcrumb-item> -->
      <el-breadcrumb-item>论文结题</el-breadcrumb-item>
    </el-breadcrumb>
    <!--返回按钮区-->
    <el-button type="primary" icon="el-icon-arrow-left" @click="back">返回</el-button>
    <el-container>
      <el-main>
        <el-descriptions :title="projectdetail.projectName">{{ projectdetail.projectName }}
          <el-descriptions-item label="创建人">{{ leadername }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ projectdetail.startTime | formatDate }}</el-descriptions-item>
          <el-descriptions-item label="计划完成时间">{{ projectdetail.planTime | formatDate }}</el-descriptions-item>
          <el-descriptions-item label="成果归属单位">
            <el-tag size="small">{{ aodname }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="项目经费">{{ projectdetail.outlay }}元</el-descriptions-item>
        </el-descriptions>
        <el-row>
          <el-steps :active="projectdetail.statusId" align-center>
            <el-step title="项目申请" />
            <el-step title="初审通过" />
            <el-step title="二审通过" />
            <el-step title="结题申请" />
            <el-step title="项目完成" />
          </el-steps>
        </el-row>
        <el-row>
          <el-row>团队成员列表</el-row>
          <el-table :data="projectdetail.team" border stripe style="width: 1200px;">
            <el-table-column type="index" label="#" />
            <el-table-column label="成员姓名" prop="userRealname" />
            <el-table-column label="成员电话" prop="userMobile" />
            <el-table-column label="成员邮箱" prop="userEmail" />
            <el-table-column label="成员学工号" prop="userNumber" />
          </el-table>
        </el-row>
        <el-row :gutter="20">

          <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">

            <el-form-item>
              <el-col :span="11">
                <el-form-item label="论文题目" prop="papername">
                  <el-input v-model="ruleForm.papername" type="text" placeholder="请输入论文题目" />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="论文类型" prop="ptid">
                  <el-select v-model="ruleForm.ptid" :append-to-body="false" placeholder="请选择论文类型" @focus="getptidlist()">
                    <el-option
                      v-for="(item,index) in ptidlist"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="11">
                <el-form-item label="收录号" prop="includenumber">
                  <el-input v-model="ruleForm.includenumber" type="text" placeholder="请输入收录号" />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="期刊类型" prop="periodicalid">
                  <el-select v-model="ruleForm.periodicalid" placeholder="请选择期刊类型" @focus="getperiodicalidlist()">
                    <el-option
                      v-for="(item,index) in periodicalidlist"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="11">
                <el-form-item label="发表时间" required prop="publishtime">
                  <el-date-picker v-model="ruleForm.publishtime" type="date" placeholder="选择日期" style="width: 100%;" :picker-options="pickerOptions0" />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="19">
                <el-form-item label="备注" prop="remark">
                  <el-input v-model="ruleForm.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 10}" maxlength="1000" show-word-limit />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col>
                <el-form-item label="上传论文" prop="paperfile">
                  <el-upload
                    ref="upload"
                    class="upload-demo"
                    :disabled="(projectdetail.statusId) !== 3? true : false"
                    :action="uploadUrl2()"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :data="upData2"
                    :on-error="uploadFalse2"
                    :on-success="uploadSuccess2"
                    :auto-upload="false"
                    :before-upload="beforeAvatarUpload2"
                  >
                    <el-button slot="trigger" :disabled="(projectdetail.statusId) !== 3? true : false" size="small" type="primary">选取文件</el-button>
                    <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
                    <div slot="tip" class="el-upload__tip">请上传论文！</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item>
              <el-col :span="11">
                <el-form-item label=" ">
                  <el-button v-preventReClick="3000" :disabled="(projectdetail.statusId) !== 3? true : false" type="primary" @click="paperendapply('ruleForm')">提交申请</el-button>
                  <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-form>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Paperend',
  filters: {
    formatDate: function(value) {
      const date = new Date(value)
      const y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? ('0' + MM) : MM
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      let m = date.getMinutes()
      m = m < 10 ? ('0' + m) : m
      let s = date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
    }
  },
  data() {
    return {
      projectdetail: this.$route.params.projectdetail, // 项目所有信息
      paperid: '', // 预申请id
      ptidlist: [],
      periodicalidlist: [],
      leadername: '',
      aodname: '',
      paperfileform: { // 文件上传表单
        primaryId: '',
        projectId: '',
        atId: '',
        categoryId: '',
        file: ''
      },
      paperform: { // 上传数据
        aodId: '',
        includeNumber: '',
        leaderId: '',
        paperId: '',
        paperName: '',
        periodicalId: '',
        projectId: '',
        ptId: '',
        publishTime: '',
        remark: '',
        scId: '',
        sdId: '',
        subjectId: ''
      },
      paperform2: { // 上传表单格式数据
        data: {}
      },
      ruleForm: { // 表单
        papername: '',
        includenumber: '',
        periodicalid: '',
        publishtime: '',
        ptid: '',
        remark: ''
      },
      rules: {
        papername: [
          { required: true, message: '请填写论文题目', trigger: 'blur' },
          { max: 32, message: '长度不能超过 32 个字符', trigger: 'blur' }
        ],
        includenumber: [
          { required: true, message: '请填写收录号', trigger: 'blur' },
          { pattern: /^[0-9]*$/, message: '收录号不符合规范，应为数字', trigger: 'blur' }
        ],
        periodicalid: [
          { required: true, message: '请选择期刊类型', trigger: 'change' }
        ],
        ptid: [
          { required: true, message: '请选择论文类型', trigger: 'change' }
        ],
        publishtime: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请填写备注', trigger: 'blur' }
        ]
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  computed: {
    // 这里定义上传文件时携带的参数，即表单数据
    upData2: function() {
      // console.log('........')
      return this.paperfileform
    }
  },
  created() {
    this.projectdetail = JSON.parse(sessionStorage.getItem('projectdetail')) // 获取项目详情信息
    this.getproductid() // 预创建id
    this.getleadername(this.projectdetail) // 查询负责人姓名
    this.getaodname(this.projectdetail) // 查询归属单位姓名
  },
  methods: {

    /**
     * @description: 返回
     * @param {*}
     * @return {*}
     * @author: Haiting Zhao
     */
    back() {
      this.$router.go(-1)
    },

    /**
     * @description: 预创建id
     * @param {*}
     * @return {*}
     * @author: Haiting Zhao
     */
    getproductid() {
      axios.get('/applyFile/advance')
        .then(res => {
          this.paperid = res.data.data
          // console.log(this.paperid)
        })
        .catch(err => {
          console.error(err)
        })
    },

    /**
     * @description: 获取论文类型
     * @param {*}
     * @return {*}
     * @author: Haiting Zhao
     */
    getptidlist() {
      this.ptidlist = JSON.parse(this.$store.getters.getpt).filter(function(ele) { return ele !== null })
    },

    /**
     * @description: 获取期刊类型
     * @param {*}
     * @return {*}
     * @author: Haiting Zhao
     */
    getperiodicalidlist() {
      this.periodicalidlist = JSON.parse(this.$store.getters.getperiodical).filter(function(ele) { return ele !== null })
    },

    /**
     * @description: 查询负责人姓名
     * @param {*} params
     * @return {*}
     * @author: Haiting Zhao
     */
    getleadername(params) {
      var a = params.leaderId
      for (var i = 0; i < params.team.length; i++) {
        if (a === params.team[i].userId) {
          this.leadername = params.team[i].userRealname
        }
      }
    },

    /**
     * @description: 查询归属单位名称
     * @param {*} params
     * @return {*}
     * @author: Haiting Zhao
     */
    getaodname(params) {
      this.aodname = JSON.parse(this.$store.getters.getdepartment)
      this.aodname = this.aodname[params.aodId].name
    },

    /**
     * @description: 移除文件
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     * @author: Haiting Zhao
     */
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },

    /**
     * @description: 预览
     * @param {*} file
     * @return {*}
     * @author: Haiting Zhao
     */
    handlePreview(file) {
      console.log(file)
    },

    /**
     * @description: 上传论文接口
     * @param {*}
     * @return {*}
     * @author: Haiting Zhao
     */
    uploadUrl2: function() {
      return 'api/applyFile/updateFile/paper' // 上传论文接口
    },

    /**
     * @description: 上传前对文件的大小和类型的判断
     * @param {*} file
     * @return {*}
     * @author: Haiting Zhao
     */
    beforeAvatarUpload2(file) {
      this.paperfileform.primaryId = this.paperid
      this.paperfileform.projectId = this.projectdetail.projectId
      this.paperfileform.atId = this.projectdetail.atId
      this.paperfileform.categoryId = this.ruleForm.ptid
      this.paperfileform.file = file.name
      this.paperfileform.file = file
      // console.log(this.paperfileform.file)
      return 1
    },

    /**
     * @description: 上传论文
     * @param {*} paperfileform
     * @return {*}
     * @author: Haiting Zhao
     */
    submitUpload2(paperfileform) {
      var files = this.$refs.upload.uploadFiles
      if (files.length === 0) {
        this.$message({
          message: '请先上传论文材料!',
          type: 'error'
        })
        return
      }
      this.$refs.upload.submit()
    },

    /**
     * @description: 论文文件上传成功触发
     * @param {*} response
     * @return {*}
     * @author: Haiting Zhao
     */
    uploadSuccess2(response) {
      // console.log(response)
      if (response.code === 200) {
        this.$message({
          message: '导入论文成功',
          type: 'success'
        })
        axios.post('/applyFile/updateData/paper', this.paperform2)
          .then(() => {
            this.$message.success('论文成果申请成功！')
            this.$router.go(-1)
          })
          .catch(err => {
            this.$message.success('论文成果申请失败！')
            console.error(err)
          })
      } else if (response.code === 417) {
        this.$message({
          message: response.msg,
          type: 'error'
        })
      } else {
        this.$message({
          message: '导入论文失败',
          type: 'error'
        })
      }
    },

    /**
     * @description: 论文上传失败触发
     * @param {*} response
     * @return {*}
     * @author: Haiting Zhao
     */
    uploadFalse2(response) {
      // console.log(response)
      this.$message({
        message: '论文上传失败！',
        type: 'error'
      })
    },

    /**
     * @description: 论文结题提交
     * @param {*} formName
     * @return {*}
     * @author: Haiting Zhao
     */
    paperendapply(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!')
          this.paperform.aodId = this.projectdetail.aodId
          this.paperform.includeNumber = this.ruleForm.includenumber
          this.paperform.leaderId = this.projectdetail.leaderId
          this.paperform.paperId = this.paperid
          this.paperform.paperName = this.ruleForm.papername
          this.paperform.periodicalId = this.ruleForm.periodicalid
          this.paperform.projectId = this.projectdetail.projectId
          this.paperform.ptId = this.ruleForm.ptid
          this.paperform.publishTime = this.ruleForm.publishtime
          this.paperform.remark = this.ruleForm.remark
          this.paperform.scId = this.projectdetail.scId
          this.paperform.sdId = this.projectdetail.sdId
          this.paperform.subjectId = this.projectdetail.subjectId
          this.paperform2.data = this.paperform
          this.submitUpload2()
        } else {
          console.log('论文文件未上传或上传失败！请稍后重试')
          return false
        }
      })
    },

    /**
     * @description: 清空表单
     * @param {*} formName
     * @return {*}
     * @author: Haiting Zhao
     */
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="scss">
.el-main>.el-row {
  margin-top: 15px;
  margin-bottom: 15px;
  /* margin: 20px auto; */
  /* padding-bottom: 30px; */
  /* padding-left: 25%; */
  /* border-top: 1px solid rgb(221, 221, 221); */
}
</style>
